import React from "react"
import styled from "styled-components"
import TitleGroup from './common/TitleGroup'

import { graphql, StaticQuery } from 'gatsby'
import BackgroundImage from 'gatsby-background-image'
import { depoimentos } from './data/depoimentos'

import Element from './common/element'

const Container = styled.div`
  
  @media(min-width: 920px) {
    margin-top: -30px;
  }
`
const WrapperElement = styled.div`
  display: flex;
  justify-content: flex-end;
`
const WrapperContent = styled.div`
  padding-top: 50px;
    & > div {
    max-width: 600px;
  }
    @media(max-width: 919px) {
    display: flex;
    justify-content: center;
  }
` 
const Items = styled.ul`
  list-style: none;
  display: grid;

  grid-template-columns: 1fr 1fr;
  @media(max-width: 919px) {
    grid-template-columns: 1fr;
  }
  gap: 2rem;
  color: var(--cPrimary);
  padding-left: 0;
  margin-top: 50px;
  padding-bottom: 80px;
  margin-bottom: 0;

  @media(min-width: 1240px) {
    grid-gap: 5rem;
  }
`

const ItemTitle = styled.h4`
  margin-top: 40px;
  margin-bottom: 10px;
  font-size: 1.2rem;
  @media(max-width: 919px) {
    text-align: center;
  }
`
const Item = styled.li`
  display: flex;
  position: relative;
  gap: 2rem;
  @media(max-width: 919px) {
    flex-direction: column;
    align-items: center;
  }
  i {
    color: var(--cPrimaryLight);
  }
  a {
    i {
      cursor: pointer;
    }
  }

`
const ItemIcon = styled.span`
    background-color: #E2EAFF;
    border-radius: 10px;
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    i {
      margin: auto;
      font-size: 20px;
      font-weight: 400;
    }
`

const ItemDescription = styled.p`
  font-weight: 300;
  font-size: 1rem;
  line-height: 22px;
  margin-top: 0;
  width: 248px;
  max-width: 100%;
  @media(max-width: 919px) {
    text-align: center;
  }
  
`
const ItemWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media(max-width: 919px) {
      align-items: center;
    }
`

const ItemImg = styled.div`
    display: block;
    max-width: 100%;
    width: 250px;
`

const BackgroundSection = ({ className, handle }) => (
  <StaticQuery
    query={graphql`
      query {
        desktop: file(relativePath: { eq: "bg_depo.png" }) {
          childImageSharp {
            fluid(maxWidth: 486, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => {
      const sources = [
        data.desktop.childImageSharp.fluid,
      ]
      return (
        <BackgroundImage
          Tag="section"
          className={className}
          fluid={sources}
          fadeIn={false}
        >
         <section className="mSection">
            <div className="container" id="novidades" data-aos='zoom-out' data-aos-duration="600">
                <WrapperContent>
                  <div>
                    <TitleGroup supTitle="Depoimento dos diretores" title="Os diretores de operação e tecnologia tem um recado para você :)" icon="far fa-quote-left">
                    <p>Produzir o TagPlus 2.0 foi uma tarefa árdua e desafiadora. Veja o que nossos diretores têm a dizer sobre o processo de desenvolvimento do projeto.</p>
                    </TitleGroup>
                  </div>
                 
                </WrapperContent>
                
                <div>
                <Items>
                  {depoimentos.map(item =>
                    <Item key={item.key}>
                      <ItemImg data-aos='flip-left' data-aos-duration="600">
                        {item.img}
                      </ItemImg>
                      
                      <ItemWrapper>
                        
                        <ItemIcon>
                        <i className={item.icon} />
                        </ItemIcon>
                        
                        <div>
                          
                          <ItemDescription>{item.description}</ItemDescription>
                          <ItemTitle>{item.name}</ItemTitle>
                          <ItemDescription>{item.cargo}</ItemDescription>
                        </div>
                        <a href={item.social_link} target="__blank"><i className="fab fa-linkedin-in"></i></a>
                    
                        </ItemWrapper>
                    </Item>
                  )}
                </Items>
                
                </div>
              
            
            </div>
          </section>
        </BackgroundImage>
      )
    }}
  />
)


const StyledBackgroundSection = styled(BackgroundSection)`
  width: 100%;
  height: 100%;
  background-position: right;
  background-position-x: right;
  background-repeat: no-repeat;
  background-size: contain;
  opacity: 1;
  padding-bottom: 80px;
  @media(min-width: 705px){
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  justify-items: center;
  }

  &::after, &::before {
    opacity: 1 !important;
  }

`
const Novidades = ({ handle }) => (
  <Container className="mSection bgLight">
    <div className="container">
      <WrapperElement>
      <Element color="var(--cPrimaryLight)" top={true} />
      </WrapperElement>
      
    </div>
    
   <StyledBackgroundSection handle={handle} />
  </Container>
 )
export default Novidades
